<script>
export default {
  props: {
    scrollStatus: {
      type: Number
    }
  },
  data: () => ({
    twitter: false
  }),
  watch: {
    scrollStatus (value) {
      if (value === 2 && this.twitter === false) {
        this.twitter = true
        const script = document.createElement('script')
        script.setAttribute('src', 'https://platform.twitter.com/widgets.js')
        script.setAttribute('charset', 'utf-8')
        const parent = document.querySelector('.twitter-embed')
        parent.insertBefore(script, null)
      }
    }
  }
}
</script>

<template>
  <footer class="global-footer has-text-weight-bold is-family-oswald">
    <div class="footer-container">
      <div class="footer-twitter">
        <h1 class="is-size-2">
          <a
            href="https://twitter.com/GrePre_anime"
            target="_blank"
            rel="noopener"
          >
            <span>X</span>
            <span>@GrePre_anime</span>
          </a>
        </h1>
        <div class="twitter-embed">
          <a
            class="twitter-timeline"
            data-height="311"
            data-theme="dark"
            href="https://twitter.com/GrePre_anime?ref_src=twsrc%5Etfw"
            data-chrome="noheader nofooter noborders"
          >
            Tweets by GrePre_anime
          </a>
        </div>
      </div>
      <div class="footer-brand">
        <div class="footer-logo">
          <router-link :to="{name: 'home'}">
            <img src="/assets/images/logo-gp-w-w_2x.png" alt="GREAT PRETENDER">
          </router-link>
          <p class="is-size-3 has-text-align-center">©WIT STUDIO/Great Pretenders</p>
        </div>
        <div class="brand-logo level is-mobile">
          <a
            class="netflix"
            href="https://www.netflix.com/jp/"
            target="_blank"
            rel="noopener"
          >
            <img src="@/assets/logo-netflix_2x.png">
          </a>
          <a
            class="plus-ultra"
            href="https://plus-ultra.tv/"
            target="_blank"
            rel="noopener"
          >
            <img src="@/assets/logo-plus-ultra_2x.png">
          </a>
          <a
            class="dmm"
            href="https://tv.dmm.com/vod/"
            target="_blank"
            rel="noopener"
          >
            <img src="/assets/images/logo-dmm-w.svg">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.global-footer {
  position: relative;
  z-index: 1;
  background-color: #000;
  width: 100%;
  color: $white;
  .footer-container {
    @include is-not-mobile {
      height: 31rem;
      min-width: $min-width;
      max-width: $min-width;
      margin: auto;
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
    .footer-twitter {
      h1 {
        color: $red-dark;
        line-height: 1.25rem;
        margin-bottom: 1rem;
        @include is-mobile {
          margin-bottom: .5rem;
        }
        span {
          margin-right: 1rem;
        }
      }
    }
  }
.footer-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  @include is-not-mobile {
    .footer-brand {
      padding: 4rem 2rem;
    }
    .footer-twitter  {
      width: 40rem;
      padding: 4rem 2rem;
    }
    .footer-logo img {
      width: 20rem;
    }
    .brand-logo {
      padding-top: 2.5rem;
    }
  }
  @include is-mobile {
    .footer-logo{
      text-align: center;
    }
    .footer-brand {
      padding: 3rem 1rem;
    }
    .footer-twitter {
      overflow: hidden;
      max-width: calc(100% - 4rem);
      padding-top: 2rem;
      margin: auto;
    }
    .footer-logo img {
      width: 100%;
      max-width: 20rem;
    }
    .brand-logo {
      padding: .5rem 0;
    }
  }
  .twitter-embed {
    height: 20rem;
  }
  .brand-logo {
    @include is-not-mobile {
      width: 27rem;
    }

    img {
      @include is-not-mobile {
        width: 8.5rem;
      }
      @include is-mobile {
        width: 7rem;
      }
    }

    .dmm {
      img {
        box-sizing: border-box;
        @include is-mobile {
          width: 8rem;
        }
        @include is-not-mobile {
          width: 9.5rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/global-footer.vue